import { Button, Checkbox, Col, DatePicker, Row, Select, Table } from 'antd'
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { formatDate, subDays } from 'date-fns';
import { MultiaxisLineChart } from 'charts/MultiaxisLineChart';
import AddGraphical from 'components/Popup/Add_Graphical';
import { getFeatureNames, getPartners, getDataStatistics, getGraphicalStatistics } from 'services/TuViReport';
import { TUVI_DIMENSIONS, TUVI_METRICS, PATH, PAGE_TITLE, EXPORT_FILENAME } from './constants';
import { exportTableToExcel, formatNumber, isNumber, toNumber } from 'helpers';
import checkPermissionFunction from 'Permission';
import { useDispatch } from 'react-redux';
import { setAppLoading } from 'app/slices/appSlice';

dayjs.extend(customParseFormat);
const { RangePicker } = DatePicker;

const rangePresets = [
      {
            label: '7 ngày trước',
            value: [dayjs().add(-7, 'd'), dayjs()],
      },
      {
            label: '14 ngày trước',
            value: [dayjs().add(-14, 'd'), dayjs()],
      },
      {
            label: '30 ngày trước',
            value: [dayjs().add(-30, 'd'), dayjs()],
      },
      {
            label: '90 ngày trước',
            value: [dayjs().add(-90, 'd'), dayjs()],
      },
];

const path = PATH;

function SuDungDichVuTuVi() {

      // Shared
      const now = new Date();
      const [isLoading, set_isLoading] = useState(true);
      const [open, set_open] = useState(false);
      const [showModal, set_showModal] = useState(false);
      const [defaultData, set_defaultData] = useState({});

      // before applying
      const [before_data, set_before_data] = useState({
            startTime: formatDate(subDays(now, 30), "dd/MM/yyyy"),
            endTime: formatDate(now, "dd/MM/yyyy"),
            featureNames: [],
            partnerIds: [],
      });

      // Apply
      const [current_data, set_current_data] = useState({
            startTime: formatDate(subDays(now, 30), "dd/MM/yyyy"),
            endTime: formatDate(now, "dd/MM/yyyy"),
            featureNames: [],
            partnerIds: [],
      });

      //graphical
      const [condition, set_condition] = useState([{ metricIds: [1], dimensionIds: [] }]);
      const [data_graphical, set_graphical] = useState([]);

      // Table
      const [conditionTable, set_conditionTable] = useState({ metricIds: [1, 2], dimensionIds: [1] });
      const [colSpan, set_colSpan] = useState(conditionTable.dimensionIds.length);

      const [dataTable, set_dataTable] = useState([]);
      const [data_export, set_data_export] = useState({});

      const [columns, set_columns] = useState([]);
      const [fixedColumns, set_fixedColumns] = useState([]);

      const dispatch = useDispatch();

      useEffect(() => {
            async function Refresh() {
                  dispatch(setAppLoading(true));

                  const obj = Object.assign({}, defaultData);

                  // Lấy Feature Names từ API
                  const featureNamesRes = await getFeatureNames();
                  obj.featureNames = featureNamesRes?.data?.data?.map((name) => {
                        return { label: name, value: name };
                  }) ?? [];

                  // Lấy danh sách Đối tác từ API (value là identifier, gửi lên qua partnerIds)
                  const partnersRes = await getPartners();
                  obj.partners = partnersRes?.data?.data?.map((partner) => {
                        return { label: partner.name, value: partner.id };
                  }) ?? [];

                  // Sử dụng Hardcode Constants thay vì gọi API
                  obj.dimensions = TUVI_DIMENSIONS;
                  obj.metrics = TUVI_METRICS;

                  set_defaultData(obj);

                  const data_Table = await getDataStatistics(Object.assign({}, current_data, conditionTable));

                  converData(data_Table?.data?.data);

                  const data_graphical = await getGraphicalStatistics(Object.assign({}, current_data, condition[0]));

                  set_graphical([data_graphical?.data?.data]);
                  set_isLoading(false);
                  dispatch(setAppLoading(false));

            }
            Refresh();
      }, []);

      function converData(data) {
            if (!data || !data.statistics || !data.statistics[0]) {
                  set_columns([]);
                  set_dataTable([]);
                  set_data_export({});
                  set_fixedColumns([]);
                  return;
            }

            const columnstmp = Object.keys(data.statistics[0] || {}).map(key => {
                  const { name, type, id } = data.statistics[0][key];
                  return {
                        title: name, dataIndex: name, width: 150,
                        sorter: isSortable(type, id) ? (a, b) => set_sorter(a, b, name) : undefined,
                  };
            });

            set_columns(columnstmp);

            let tmp = [];

            for (let i = 0; i < data.statistics.length; i++) {
                  const value = data.statistics[i].reduce((acc, item) => {
                        acc[item.name] = item.value;
                        acc.type = item.type;
                        acc.id = item.id;
                        acc.key = i;
                        return acc;
                  }, {});
                  tmp.push(value)
            }

            set_dataTable(tmp);
            set_data_export(data);
            set_fixedColumns(data.total);
      }

      function isSortable(type, id) {
            if (type == "dimension" && id != 1)
                  return false;
            return true;
      }

      function set_sorter(a, b, name) {
            if (isNumber(a?.[name])) {
                  return toNumber(a?.[name]) - toNumber(b?.[name]);
            }

            const regex = /^(0?[1-9]|[12][0-9]|3[01])\/(0?[1-9]|1[0-2])\/(\d{4})$/;

            if (regex.test(a?.[name])) {
                  const [aDay, aMonth, aYear] = a?.[name].split('/').map(Number);
                  const [bDay, bMonth, bYear] = b?.[name].split('/').map(Number);
                  return new Date(aYear, aMonth - 1, aDay) - new Date(bYear, bMonth - 1, bDay);
            }
            return false;
      }

      function onOpenChange(open) {
            set_open(open);
      }

      function onCalendarChange(dates) {
            let obj = Object.assign({}, before_data);
            obj.startTime = dayjs(dates[0]).format('DD/MM/YYYY');
            obj.endTime = dayjs(dates[1]).format('DD/MM/YYYY');

            if (open == true) {
                  set_before_data(obj);
            }
      }

      function onChangeField(field, value) {
            let obj = Object.assign({}, before_data);
            obj[field] = value.map(item => item.label);
            set_before_data(obj);
      }

      async function onClickAplly(length) {
            dispatch(setAppLoading(true));

            let tmp = [];
            for (let i = 0; i < length; i++) {
                  const data_graphical = await getGraphicalStatistics(Object.assign({}, before_data, condition[i]));
                  tmp.push(data_graphical?.data?.data);
            }
            set_graphical(tmp);
            set_current_data(before_data);

            const data_Table = await getDataStatistics(Object.assign({}, before_data, conditionTable));

            converData(data_Table?.data?.data);
            dispatch(setAppLoading(false));
      }

      async function changeDimension(id, index) {

            let obj = { ...condition[index] };

            if (id == 0) {
                  obj.dimensionIds = [];

            } else {
                  obj.dimensionIds = [Number(id)];
            }

            let tmp = [...condition];
            tmp[index] = obj;
            set_condition(tmp);

            const graphical = await getGraphicalStatistics(Object.assign({}, current_data, obj));

            let graphicals = [...data_graphical];
            graphicals[index] = graphical?.data?.data;
            set_graphical(graphicals);
      }

      async function changeMetrics(id, index) {

            let obj = { ...condition[index] };
            obj.metricIds = [Number(id)];

            let tmp = [...condition];
            tmp[index] = obj;
            set_condition(tmp);

            const graphical = await getGraphicalStatistics(Object.assign({}, current_data, obj));

            let graphicals = [...data_graphical];
            graphicals[index] = graphical?.data?.data;
            set_graphical(graphicals);
      }

      async function onAddGraphical(metric, dimention) {
            dispatch(setAppLoading(true));
            let tmp = [...condition];
            tmp.push({ metricIds: [metric], dimensionIds: dimention == 0 ? [] : [dimention] });

            const graphical = await getGraphicalStatistics(Object.assign({}, current_data, { metricIds: [metric], dimensionIds: dimention == 0 ? [] : [dimention] }));

            let graphicals = [...data_graphical];
            graphicals.push(graphical?.data?.data);
            set_graphical(graphicals);

            set_condition(tmp);
            dispatch(setAppLoading(false));
      }

      async function onChangeDimentionTable(id, status) {
            let obj = Object.assign({}, conditionTable);

            if (status == true) {
                  if (!conditionTable.dimensionIds.includes(Number(id))) {
                        obj.dimensionIds.push(Number(id));
                  }
            } else {
                  obj.dimensionIds = obj.dimensionIds.filter(item => item != Number(id));
            }

            obj.dimensionIds = obj.dimensionIds.sort();

            set_conditionTable(obj);
      }

      function onChangeMetricTable(id, status) {
            let obj = Object.assign({}, conditionTable);

            if (status == true) {
                  if (!conditionTable.metricIds.includes(Number(id))) {
                        obj.metricIds.push(Number(id));
                  }
            } else {
                  obj.metricIds = obj.metricIds.filter(item => item != Number(id));
            }

            obj.metricIds = obj.metricIds.sort();

            set_conditionTable(obj);
      }

      async function onChangeTable() {
            dispatch(setAppLoading(true));

            const data_Table = await getDataStatistics(Object.assign({}, current_data, conditionTable));

            converData(data_Table?.data?.data);

            set_colSpan(conditionTable.dimensionIds.length);
            dispatch(setAppLoading(false));
      }

      return (
            <div className="container-fluid">
                  {
                        showModal && <AddGraphical
                              dimensions={defaultData?.dimensions}
                              metrics={defaultData?.metrics}
                              onClose={() => set_showModal(false)}
                              onChange={onAddGraphical}
                        />
                  }
                  {
                        isLoading == false && <div className="card card-body flex gap-3">
                              <div className='flex'>
                                    <div className='w-full'>
                                          <h2>{PAGE_TITLE}</h2>
                                    </div>
                                    <div className='w-full flex justify-content-end gap-3'>
                                          <Button type="primary"
                                                onClick={() => {
                                                      checkPermissionFunction(path, 'export', () =>
                                                            exportTableToExcel(data_export, colSpan, EXPORT_FILENAME)
                                                      );

                                                }}
                                          >Export</Button>
                                          <Button type="primary"
                                                onClick={() => set_showModal(true)}
                                          >Thêm biểu đồ</Button>
                                    </div>
                              </div>

                              <div className="flex gap-3">
                                    <div>
                                          <div>
                                                <b>Thời gian</b>
                                          </div>
                                          <RangePicker
                                                presets={rangePresets}
                                                onOpenChange={onOpenChange}
                                                onCalendarChange={(dates) => onCalendarChange(dates)}
                                                placeholder={['Thời gian bắt đầu', 'Thời gian kết thúc']}
                                                defaultValue={[dayjs(formatDate(subDays(now, 30), "yyyy/MM/dd")), dayjs(formatDate(now, "yyyy/MM/dd")),]}
                                                format="DD/MM/YYYY"
                                          />
                                    </div>
                                    <div>
                                          <div>
                                                <b>Tính năng</b>
                                          </div>
                                          <Select
                                                style={{ width: "300px", maxWidth: "500px" }}
                                                options={defaultData?.featureNames ?? []}
                                                mode='multiple'
                                                onChange={(label, value) => {
                                                      onChangeField("featureNames", value)
                                                }}
                                                filterOption={(input, option) =>
                                                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                                }
                                          />
                                    </div>
                                    <div>
                                          <div>
                                                <b>Đối tác</b>
                                          </div>
                                          <Select
                                                style={{ width: "300px", maxWidth: "500px" }}
                                                options={defaultData?.partners ?? []}
                                                mode='multiple'
                                                onChange={(values) => {
                                                      set_before_data({ ...before_data, partnerIds: values });
                                                }}
                                                filterOption={(input, option) =>
                                                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                                }
                                          />
                                    </div>
                                    <div className='content-end'>
                                          <Button type="primary"
                                                onClick={() => onClickAplly(data_graphical.length)}
                                          >Áp dụng</Button>
                                    </div>
                              </div>
                              <div>
                                    <Row className='pt-5'>
                                          {
                                                data_graphical.map((item, index) => {
                                                      return <Col
                                                            key={index}
                                                            xs={24}    // Chiếm toàn bộ chiều rộng trên màn hình nhỏ
                                                            sm={24}    // Chiếm 1/2 chiều rộng trên màn hình nhỏ hơn
                                                            md={(index === data_graphical.length - 1 && data_graphical.length % 2 === 1) ? 24 : 12} // Điều chỉnh kích thước trên màn hình vừa và lớn hơn
                                                            lg={(index === data_graphical.length - 1 && data_graphical.length % 2 === 1) ? 24 : 12}   // Chiếm 1/2 chiều rộng trên màn hình lớn hơn
                                                            xl={(index === data_graphical.length - 1 && data_graphical.length % 2 === 1) ? 24 : 12}    // Chiếm 1/2 chiều rộng trên màn hình rất lớn
                                                            className={`${index != data_graphical.length ? "pb-5" : ""}`}
                                                      >
                                                            <div>
                                                                  <div className='flex gap-3 flex-wrap align-content-center'>
                                                                        <div className='flex gap-2'>
                                                                              <b className='align-content-center'>Metrics</b>
                                                                              <Select
                                                                                    defaultValue={defaultData?.metrics.find(item => item.id == condition[index].metricIds[0])?.name}
                                                                                    options={defaultData?.metrics.map((item) => {
                                                                                          return { label: item.name, value: item.id };
                                                                                    })}
                                                                                    style={{ width: "200px" }}
                                                                                    onChange={(e) => changeMetrics(e, index)}
                                                                              />
                                                                        </div>
                                                                        <div className='flex gap-2'>
                                                                              <b className='align-content-center'>Dimension</b>
                                                                              <Select
                                                                                    defaultValue={defaultData?.dimensions.find(item => item.id == condition[index].dimensionIds[0])?.name || "Tất cả"}
                                                                                    options={[{ label: "Tất cả", value: 0 }, ...defaultData?.dimensions.filter((item) => item.id != 1).map((item) => {
                                                                                          return { label: item.name, value: item.id };
                                                                                    })]}
                                                                                    style={{ width: "200px" }}
                                                                                    onChange={(e) => changeDimension(e, index)}
                                                                              />
                                                                        </div>
                                                                        {
                                                                              index != 0 && <Button danger onClick={() => {
                                                                                    const tmp = [...data_graphical.slice(0, index), ...data_graphical.slice(index + 1)];
                                                                                    const tmpcondiotion = [...condition.slice(0, index), ...condition.slice(index + 1)];

                                                                                    set_condition(tmpcondiotion);
                                                                                    set_graphical(tmp);
                                                                              }}>Xoá</Button>
                                                                        }
                                                                  </div>
                                                                  <MultiaxisLineChart Unprocessed_Data={item} unit="" />
                                                                  <div
                                                                        className="row mx-n2 text-center mt-2 overflow-auto"
                                                                        style={{ maxHeight: '20em' }}
                                                                  >
                                                                        {item &&
                                                                              item.total &&
                                                                              item.total.map((item1, index1) => {
                                                                                    return (
                                                                                          <span key={index1} className="col-12 col-sm-6 col-md-4 px-2">
                                                                                                <span>
                                                                                                      {item1.name}: {`${formatNumber(item1?.value)} ${item?.unit ?? ""}`}
                                                                                                </span>
                                                                                          </span>
                                                                                    );
                                                                              })}
                                                                  </div>
                                                            </div>
                                                      </Col>
                                                })
                                          }
                                    </Row>

                              </div>
                              <div>

                                    <Row gutter={[16, 16]}>
                                          <Col
                                                xs={24}
                                                sm={24}
                                                md={24}
                                                lg={20}
                                                xl={20}
                                          >
                                                <Table columns={columns}
                                                      dataSource={dataTable}
                                                      pagination={true}
                                                      scroll={{ x: 'calc(100vh)' }}
                                                      summary={() => (
                                                            <Table.Summary fixed>
                                                                  <Table.Summary.Row>
                                                                        <Table.Summary.Cell index={0} colSpan={colSpan}><b>Tổng</b></Table.Summary.Cell>
                                                                        {
                                                                              fixedColumns.map((item, index) => {
                                                                                    return (
                                                                                          <Table.Summary.Cell key={index} index={index + 1}>{formatNumber(item.value)}</Table.Summary.Cell>
                                                                                    )
                                                                              })
                                                                        }
                                                                  </Table.Summary.Row>
                                                            </Table.Summary>
                                                      )}
                                                />

                                          </Col>
                                          <Col
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={4}
                                                xl={4}
                                                className='bg-gray-100'
                                          >
                                                <div className='flex flex-col justify-between container-fluid pt-3 pb-3'>
                                                      <b>Dimension</b>
                                                      {
                                                            defaultData?.dimensions?.map((item, index) => {
                                                                  return (
                                                                        <div key={index} className='col d-flex align-items-center gap-2'>
                                                                              <Checkbox
                                                                                    onClick={(e) => onChangeDimentionTable(item.id, e.target.checked)}
                                                                                    defaultChecked={conditionTable.dimensionIds.includes(Number(item.id))}
                                                                              >
                                                                                    {item.name}
                                                                              </Checkbox>
                                                                        </div>
                                                                  )
                                                            })
                                                      }
                                                      <b>Metrics</b>
                                                      {
                                                            defaultData?.metrics?.map((item, index) => {
                                                                  return (
                                                                        <div key={index} className='col d-flex align-items-center gap-2'>
                                                                              <Checkbox
                                                                                    onClick={(e) => onChangeMetricTable(item.id, e.target.checked)}
                                                                                    defaultChecked={conditionTable.metricIds.includes(Number(item.id))}
                                                                              >
                                                                                    {item.name}
                                                                              </Checkbox>
                                                                        </div>
                                                                  )
                                                            })
                                                      }
                                                      <div className='pt-5 text-center'>
                                                            <Button type="primary"
                                                                  disabled={(conditionTable.dimensionIds.length == 0 || conditionTable.metricIds.length == 0) ? true : false}
                                                                  onClick={() => {
                                                                        onChangeTable()
                                                                  }}
                                                            >Áp dụng</Button>
                                                      </div>
                                                </div>
                                          </Col>
                                    </Row>
                                    <div className="col-2" style={{ alignItems: 'center' }}>

                                    </div>
                              </div>
                        </div>
                  }

            </div>
      )
}

export default SuDungDichVuTuVi;
